import React from "react";
import ApiCard from "../components/ApiCard";
export default function ConsentTest() {
    return (
        <ApiCard
            title="Create Consent"
            description="Create Consent Request"
            url="abdm/create-consent/"
            method="POST"
            payload={{}}
            buttonText="Create Consent"
        />
    );
}